/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  GetPermissionsBySubscriptionPlanQueryResponse,
  GetPermissionsBySubscriptionPlanPathParams,
} from "../types/GetPermissionsBySubscriptionPlan.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const getPermissionsBySubscriptionPlanQueryKey = (
  subscriptionPlan: GetPermissionsBySubscriptionPlanPathParams["subscriptionPlan"]
) =>
  [
    {
      url: "/v1/organization-settings/get-permissions-by-subscription-plan/:subscriptionPlan",
      params: { subscriptionPlan: subscriptionPlan },
    },
  ] as const

export type GetPermissionsBySubscriptionPlanQueryKey = ReturnType<
  typeof getPermissionsBySubscriptionPlanQueryKey
>

/**
 * @summary Get permissions by subscription plan
 * {@link /v1/organization-settings/get-permissions-by-subscription-plan/:subscriptionPlan}
 */
export async function getPermissionsBySubscriptionPlan(
  subscriptionPlan: GetPermissionsBySubscriptionPlanPathParams["subscriptionPlan"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetPermissionsBySubscriptionPlanQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/organization-settings/get-permissions-by-subscription-plan/${subscriptionPlan}`,
    ...requestConfig,
  })
  return res
}

export function getPermissionsBySubscriptionPlanQueryOptions(
  subscriptionPlan: GetPermissionsBySubscriptionPlanPathParams["subscriptionPlan"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getPermissionsBySubscriptionPlanQueryKey(subscriptionPlan)
  return queryOptions<
    ResponseConfig<GetPermissionsBySubscriptionPlanQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<GetPermissionsBySubscriptionPlanQueryResponse>,
    typeof queryKey
  >({
    enabled: !!subscriptionPlan,
    queryKey,
    queryFn: async ({ signal }) => {
      return getPermissionsBySubscriptionPlan(subscriptionPlan, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Get permissions by subscription plan
 * {@link /v1/organization-settings/get-permissions-by-subscription-plan/:subscriptionPlan}
 */
export function useGetPermissionsBySubscriptionPlan<
  TData = ResponseConfig<GetPermissionsBySubscriptionPlanQueryResponse>,
  TQueryData = ResponseConfig<GetPermissionsBySubscriptionPlanQueryResponse>,
  TQueryKey extends QueryKey = GetPermissionsBySubscriptionPlanQueryKey,
>(
  subscriptionPlan: GetPermissionsBySubscriptionPlanPathParams["subscriptionPlan"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetPermissionsBySubscriptionPlanQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ??
    getPermissionsBySubscriptionPlanQueryKey(subscriptionPlan)

  const query = useQuery(
    {
      ...getPermissionsBySubscriptionPlanQueryOptions(subscriptionPlan, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
